import Vue from "vue";

const templateId = +document.body.getAttribute("data-tplId") || +document.body.getAttribute("tplid");
const templatePath = "./templates/" + templateId + "/doubleinput.js";

let component = Vue.component("doubleinput", function(resolve, reject) {
  import(`${templatePath}`).then(res => {
    resolve({
      template: res.default,
      props:['opt','jsonval'],
      data() {
        return {
          templateId:templateId,
          isLabel:false,
          minmod: '',
          maxmod: ''
        }
      },
      computed:{
        labelclasstrue(){
          if (this.templateId > 35)
            return 'ok-form-label -state-active'
          return 'col-md-12 ok-label-static'
        },
        labelclassfalse(){
          if (this.templateId > 35)
            return 'ok-form-label'
          return 'col-md-12 ok-label-static -state-empty'

        },
      },
      created(){
        const urlParams = new URLSearchParams(window.location.search)
        this.minmod = urlParams.get('min_'+this.opt.name) || ''
        this.maxmod = urlParams.get('max_'+this.opt.name) || ''
      },
      watch: {
        minmod() {
          if (this.minmod==='' && this.maxmod==='' || isNaN(this.minmod) && isNaN(this.maxmod) || isNaN(this.minmod) && this.maxmod==='' || isNaN(this.maxmod) && this.minmod==='') {
            this.isLabel=false;
          } else {
            this.isLabel=true;}
        },
        maxmod() {
          if (this.maxmod==='' && this.minmod==='' || isNaN(this.minmod) && isNaN(this.maxmod) || isNaN(this.minmod) && this.maxmod==='' || isNaN(this.maxmod) && this.minmod==='') {
            this.isLabel=false;
          } else {
            this.isLabel=true;}
        },
      }
    });
  });
});
export default component;



// WEBPACK FOOTER //
// ./src/components/doubleinput.js